// extracted by mini-css-extract-plugin
export default {"colContact":"hQ2rrRzu","colIcon":"dGLlrrq_","header":"Gxio4I1o","text":"qhVu1t02","icon":"J0kX_upi","contactLabel":"AaXg5g5M","contactText":"fBhemyi0"};